import {
  createSlice,
  createAsyncThunk,
  createSelector,
} from "@reduxjs/toolkit";
import { deploymentService } from "../services/deploymentService";
import type { DeploymentState } from "../types/deployment.types";


const initialState: DeploymentState = {
  DeploymentsDst: [],
  status: {
    DeploymentsDst: "idle",
  },
  filters: {
    // Add filters if needed
  },
  filtersInitialised: true,
};


export const fetchMasterProductVersion = createAsyncThunk(
  "deploymentStore/fetchMasterProductVersion",
  async () => {
    return await deploymentService.GetProductVersions();
  },
);

const deploymentSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters(state) {
      state.filters = {
        // Add filters if needed
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMasterProductVersion.fulfilled, (state, action) => {
        state.DeploymentsDst = action.payload;
        state.status.DeploymentsDst = "succeeded";
      })
      .addCase(fetchMasterProductVersion.rejected, (state) => {
        state.status.DeploymentsDst = "failed";
      })
  },
});


export const { setFilters, clearFilters } = deploymentSlice.actions;
export default deploymentSlice.reducer;